module.exports = __webpack_public_path__ + "img/playBtn.b951a9e8.png";